import { createFileRoute } from "@tanstack/react-router";

import { PaymentHistoryPage } from "@/features/my/settings/account/billing/payments/payment-history/payment-history-page";

export const Route = createFileRoute(
  "/(member)/(protected)/my/settings/account/billing/payments/history",
)({
  component: PaymentHistoryPage,
});
